import React from 'react'
import { Separator, LayoutBand, Paragraph, colors, H2 } from '@fs/zion-ui'

const DEFAULT_HEADING_SIZE = 'H5'

const PanelHeaderLayoutBand = ({ heading, caption, headingSize = DEFAULT_HEADING_SIZE }) => {
  return (
    <LayoutBand color={colors.gray02}>
      <Separator size="xxs" />
      <H2 size={headingSize}>{heading}</H2>
      <Separator size={headingSize !== DEFAULT_HEADING_SIZE ? 'xxs' : 'xs'} />
      <Paragraph size="xs">{caption}</Paragraph>
      <Separator size="xxs" />
    </LayoutBand>
  )
}
export default PanelHeaderLayoutBand
